import { createFileRoute } from "@tanstack/react-router";
import NearshoreOutsourcingGuide from "@/pages/blog/NearshoreOutsourcingGuide";

export const Route = createFileRoute("/en/blog/nearshore-outsourcing-guide")({
  component: NearshoreOutsourcingGuide,
});
